import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import {
  Stack,
  Typography,
  Divider,
  Chip,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbDownAltIcon from "@mui/icons-material/ThumbDownAlt";
import { URL} from '../config'


const VideoFrame = () => {
  const [like, setLike] = useState(false)
  const [dislike, setDislike] = useState(false)
  const { id } = useParams();
  const [video, setVideo] = useState(null);
  const useStyles = makeStyles((theme) => ({
    frame: {
      display: "block",
      margin: "auto",
      borderRadius: "10px",
      width: "100%",
      height: "500px",
      border: "none",
    },
    chip :{
      color: '#ffffff !important',
      backgroundColor: '#575b5f6a !important',
      minWidth: '75px'
    },
    active: {
      color: '#ffffff !important',
      backgroundColor: '#4CA3FC !important',
      minWidth: '75px'
    }
  }));

  const handleLike = () => {
    let downVote = video.votes.downVotes
    let upVote = video.votes.upVotes
    setLike(!like)

    if(dislike)
      downVote = ((downVote - 1) < 0) ? 0 : (downVote - 1)

    setDislike(false)

    handleVote({
      "vote": "upVote",
      "change": "increase"
    })
    if(!like){
      upVote += 1
    }else{
      upVote = ((upVote - 1) < 0) ? 0 : (upVote - 1)
    }
    setVideo(prev => ({
      ...prev,
      votes:{
        downVotes: downVote,
        upVotes: upVote
      }
    }))
  }
  const handleDislike = () => {
    let downVote = video.votes.downVotes
    let upVote = video.votes.upVotes
    setDislike(!dislike)

    if(like)
      upVote = ((upVote - 1) < 0) ? 0 : (upVote - 1)

    setLike(false)
    handleVote({
      "vote": "downVote",
      "change": "increase"
    })

    if(!dislike){
      downVote += 1
    }else{
      downVote = ((downVote - 1) < 0) ? 0 : (downVote - 1)
    }
    setVideo(prev => ({
      ...prev,
      votes:{
        upVotes: upVote,
        downVotes: downVote
      }
    }))
  }
  
  const classes = useStyles();

  async function getVideo(id) {
    try {
      const res = await fetch(
        URL+"/v1/videos/" +
          id
      );
      const data = await res.json();
      console.log(data)
      setVideo(data);
      if(data){
        fetch(URL+"/v1/videos/"+id+"/views",{ method: 'PATCH'})
        .then(res => res.json())
        .then(data => console.log(data));
      }
    } catch (error) {
      console.log(error);
    }
  }

  const handleVote = async (payload) => {
    try{
      const res = await fetch(URL+"/v1/videos/"+id+"/votes",
                                { method: 'PATCH' }, 
                                { body: payload }
                              )
      const data = await res.json()
      console.log(data)
    }catch(error){
      console.log(error)
    }
  }

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffInMs = now - date;
    const diffInMonths = Math.floor(diffInMs / (1000 * 60 * 60 * 24 * 30));

    return `${diffInMonths} months ago`;
  };

  useEffect(() => {
    getVideo(id);
  }, [id]);

  return (
    <>
      {video ? (
        <Stack padding={4} spacing={2}>
          <iframe
            src={`https://www.${video.videoLink}`}
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className={classes.frame}
          ></iframe>
          <Typography
            variant="h5"
            component="h5"
            sx={{
              color: "white",
            }}
          >
            {video.title}
          </Typography>
          <Stack direction="row" justifyContent="space-between">
            <div>
              <Typography
                variant="body2"
                sx={{
                  color: "gray",
                }}
              >
                {video.contentRating} &#x2022; {formatDate(video.releaseDate)}
              </Typography>
            </div>
            <Stack direction='row' spacing={2}>
              <Chip
                label={video.votes?.upVotes}
                icon={<ThumbUpIcon style={{color: '#ffffff'}}/>}
                onClick={handleLike}
                className={like ? classes.active : classes.chip}
              />
              <Chip
                label={video.votes?.downVotes}
                icon={<ThumbDownAltIcon style={{color: '#ffffff'}}/>}
                className={dislike ? classes.active : classes.chip}
                onClick={handleDislike}
              />
            </Stack>
          </Stack>
          <Divider
            sx={{
              backgroundColor: "white",
            }}
          />
        </Stack>
      ) : (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={true}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
    </>
  );
};

export default VideoFrame;
